import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import FormHead from "../../components/headings/FromHead";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { submitCheck } from "../../utils/submitCheck";
import { Error } from "@progress/kendo-react-labels";
import { convertToHTML } from "draft-convert";
import DOMPurify from "dompurify";

const loginId = localStorage.getItem("loginId");

function Preview(props: any) {
  const [candidateData, setCandidateData] = useState<any>();
  const [editorState] = useState<any>(
    EditorState.createEmpty()
  );
  const [error, setError] = useState<string | undefined>("");
  const [profileSubmitted, setProfileSubmitted] = useState<boolean>(true);
  const [profilePicture , setProfilePicture] = useState<any>()

  useEffect(() => {
    setCandidateData(props.candaidateData);
    setProfileSubmitted(props.profileSubmitted);
    setProfilePicture((props && props.candaidateData && props.candaidateData.image) ? props.candaidateData.image : " ")
  }, [props]);

  const dateConvert = (date: number) => {
    return new Date(date).toLocaleDateString();
  };

  const summaryConvert = (item: any) => {
    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
          let abd = draftToHtml(
            convertToRaw(
              EditorState.createWithContent(
                convertFromRaw(JSON.parse(item))
              ).getCurrentContent()
            )
          );
          let strippedHtml = abd.replace(/<[^>]+>/g, "").replace(/amp;/g,'').replace(/&nbsp;/g, '');
          return strippedHtml;
        } catch (e) {
          return item;
        }
      }
    }
  };

  const createMarkup = (html: any) => {
    if (html && html !== null){
      if (html.includes('{"blocks')) {
        let oldblockconverteddata = convertFromRaw(JSON.parse(html));
        let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);
  
        html = JSON.stringify(oldblockdataconvertedhtml);
        html = JSON.parse(html)
        return {
          __html: DOMPurify.sanitize(html).replace(/"/g,'').replace(/<p>•\t/g,'•'),
        };
      }
      if (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>")) {
        return {
          __html: DOMPurify.sanitize(JSON.parse(html)).replace(/"/g,''),
        };
      } else {
        html = "<p>" + html + "</p>";
        return {
          __html: DOMPurify.sanitize(html).replace(/"/g,''),
        };
      }
    }
  };

  const onSubmit = () => {
    let value = submitCheck(candidateData, false);
    if (!value.error) {
      let data = {
        userLoginId: loginId,
        candidateStatus: 3,
        loginId: loginId,
        submittedBy: "FREELANCER",

      };
      props.submitCheck(value.error, data);
      
    } else {
     setError(value.errorMessage);
      
    }
  };
  return (
    <>
      <section className={Styles.resourcesProfile}>
        <div className={Styles.profileHead}>
          {!profileSubmitted && props.showSubmit && (
            <>
              <Button variant="primary" size="xxsmall" onClick={onSubmit} disabled={props.disable}>
                Submit
              </Button>
            </>
          )}
          <Button
                variant="outlined"
                size="xxsmall"
                onClick={props.editClick}
              >
                Edit Profile
          </Button>
          {error && (
            <div>
              {" "}
              <Error>{error}</Error>
            </div>
          )}
        </div>
        <div className={Styles.profileWrapper}>
          <div className={Styles.profile}>
            <div className={Styles.phead}>
              <div className={Styles.pheadDetails}>
                <figure>
                  {profilePicture && profilePicture === " " ?
                   (
                    candidateData &&
                    candidateData.firstName.charAt(0) +
                      candidateData.lastName.charAt(0)
                  ) :
                  (
                    <img src={profilePicture} alt="profilepicture"/>
                  )  
                 
                  }
                </figure>
                <div className={Styles.details}>
                  <h2>
                    {candidateData &&
                      candidateData.firstName + " " + candidateData.lastName}
                  </h2>
                  <h3>
                    {candidateData &&
                      candidateData.jobRoles && candidateData.jobRoles[0] &&
                      candidateData.jobRoles[0].name}
                  </h3>
                  <p>
                    {candidateData &&
                      candidateData.address &&
                      candidateData.address.city}{" "}
                     {candidateData && candidateData.country}{candidateData && candidateData.preference && candidateData.preference.timeZone && candidateData && candidateData.preference.timeZone.map((item: any, key: number) => {
                      return (
                       ' || '+ item.slice(0,9)
                      )
                    })}
                  </p>
                </div>
              </div>
              <div className={Styles.socialWrap}>
                <p className={Styles.email}>
                  {candidateData && candidateData.email}
                </p>
                <p className={Styles.phone}>
                  +{candidateData && candidateData.phoneNumber}
                </p>
                <div className={Styles.social}>
                  {candidateData && candidateData.linkedIn && (
                    <Link
                      to={`http://${candidateData.linkedIn}`}
                      target="_blank"
                    >
                      <Icon icon="jam:linkedin-circle" />
                    </Link>
                  )}
                  {candidateData && candidateData.github && (
                    <Link to={`http://${candidateData.github}`} target="_blank">
                      <Icon icon="jam:github-circle" />
                    </Link>
                  )}
                  {candidateData && candidateData.stackoverflow && (
                    <Link
                      to={`http://${candidateData.stackoverflow}`}
                      target="_blank"
                    >
                      <Icon icon="jam:stackoverflow-circle" />
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className={Styles.pSummry}>
            {candidateData && (
                  <div
                    className="preview"
                    dangerouslySetInnerHTML={
                      candidateData && createMarkup(candidateData.summary)
                    }
                  ></div>
                )}              <FormHead>
                {candidateData &&
                  candidateData.techStack && 
                  candidateData.techStack.length > 0 && 
                  candidateData.techStack[0] !== undefined &&
                  <strong>Core Skills</strong>}
              </FormHead>
              <div className={Styles.skillsWrap}>
                {candidateData &&
                  candidateData.techStack &&
                  candidateData.techStack.map((item: any) => {
                    return (
                      <div className={Styles.skills}>
                        {item.skill.skillName}
                      </div>
                    );
                  })}
              </div>
              <FormHead>
                  {candidateData &&
                    candidateData.otherSkills &&
                    candidateData.otherSkills.length > 0 &&
                    candidateData.otherSkills[0] !== undefined && (
                    <strong>Additional Skills</strong>
                  )}
                </FormHead>
                <div className={Styles.skillsWrap}>
                  {candidateData &&
                    candidateData.otherSkills &&
                    candidateData.otherSkills.map((item: any) => {
                      return (
                        <div className={Styles.skills}>
                          {item.skillName}
                        </div>
                      );
                    })}
                </div>  
              {candidateData &&
                candidateData.workHistory && candidateData.workHistory.length > 0 && candidateData.workHistory[0] !== undefined && <div className={Styles.subHead}>WORK HISTORY</div>}
              {candidateData &&
                candidateData.workHistory &&
                candidateData.workHistory.map((item: any) => {
                  return (
                    <div>
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.companyName}</h4>
                          <p>{item.designation}</p>
                        </div>
                        <div className={Styles.date}>
                          {dateConvert(item.startDate)} –{" "}
                          {item.endDate ? dateConvert(item.endDate) : "Present"}
                        </div>
                      </div>
                      <p>
                        {item.description && summaryConvert(item.description)}
                      </p>
                    </div>
                  );
                })}
              {candidateData &&
                candidateData.project && candidateData.project.length > 0 && candidateData.project[0] !== undefined && <div className={Styles.subHead}>Projects</div>}
              {candidateData &&
                candidateData.project &&
                candidateData.project.map((item: any) => {
                  return (
                    <div>
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.name}</h4>
                          <p>Client: {item.companyName}</p>
                        </div>
                        {/* <div className={Styles.date}>
                          {item.doneFor ? 'doneFor: ' + item.doneFor : ''}
                        </div> */}
                      </div>
                      <div className={Styles.projectSkills}>
                        {item.skills &&
                          item.skills.length !== 0 &&
                          item.skills.map((item: any, key: number) => {
                            return (
                              <div className={Styles.item}>
                                {item.skillName}
                              </div>
                            );
                          })}{" "}
                      </div>
                      <p>
                        {item.contribution && summaryConvert(item.contribution)}
                      </p>
                    </div>
                  );
                })}

              {candidateData &&
                candidateData.education && candidateData.education.length > 0 && candidateData.education[0] !== undefined && <div className={Styles.subHead}>Academic Details</div>}
              {candidateData &&
                candidateData.education &&
                candidateData.education.map((item: any) => {
                  return (
                    <div className={Styles.expHead}>
                      <div className={Styles.title}>
                        <h4>{item.institution}</h4>
                        <p>{item.degree} </p>
                      </div>
                      <div className={Styles.date}>
                        {item.startDate
                          ? dateConvert(item.startDate) + " - "
                          : ""}
                        {item.endDate ? dateConvert(item.endDate) : "Present"}
                      </div>
                    </div>
                  );
                })}
              {candidateData &&
                candidateData.certification && candidateData.certification.length > 0 && candidateData.certification[0] !== undefined && <div className={Styles.subHead}>Awards and Certifications</div>}
              {candidateData &&
                candidateData.certification &&
                candidateData.certification.map((item: any) => {
                  return (
                    <div className={Styles.expHead}>
                      <div className={Styles.title}>
                        <h4>{item.name}</h4>
                        <p>{item.certifiedYear} </p>
                      </div>
                    </div>
                  );
                })}
              {candidateData &&
                candidateData.language && candidateData.language.length > 0 && candidateData.language[0] !== undefined && <div className={Styles.subHead}>languages</div>}
              {candidateData &&
                candidateData.language &&
                candidateData.language.map((item: any) => {
                  return (
                    <div className={Styles.expHead}>
                      <div className={Styles.title}>
                        <h4>{item.name}</h4>
                        <p>{item.proficiency} </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          {/* <div className={Styles.shareandprint}>
            <button>
              <Icon icon="charm:share" />
            </button>
            <button>
              <Icon icon="lucide:printer" />
            </button>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Preview;
